import React from "react";
import { Link } from "react-router-dom";

export function Logo({ size = "text-2xl" }) {
  return (
    <Link to="/" data-testid="brand-logo" className="flex flex-col items-start leading-none group">
      <span className={`font-serif font-bold tracking-[0.35em] gold-text ${size}`}>MYSE</span>
      <span className="text-[9px] tracking-[0.3em] text-[#A19E95] uppercase mt-1 hidden sm:block">
        Meet Your Star Exclusively
      </span>
    </Link>
  );
}
